import React, { useEffect, useState } from "react";
import GlobalDialog from "../../../../components/mui/Dialogue/GlobalDialog";
import {
  AddButton,
  CancelButton,
  SubmitButton,
  UpdateButton,
} from "../../../../components/mui/Buttons/Buttons";
import { useFormik, Form, FormikProvider } from "formik";
import { Autocomplete, Box, Stack, TextField } from "@mui/material";
import GlobalSelectField from "../../../../components/mui/GlobalSelectField";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  assignCros,
  getCrmLeads,
  getCroList,
} from "../../../../redux/features/crmSlice";
import * as Yup from "yup";
import { useSnackbar } from "notistack";
import { savePaginationData } from "../../../../redux/features/globalDatagridSlice";

const CustomTextField = ({
  multiline,
  name,
  label,
  dataRow,
  rows,
  key,
  ...props
}) => (
  <TextField
    name={name}
    label={label}
    value={dataRow[name]}
    // onChange={formik.handleChange}'
    disabled
    fullWidth
    rows={rows}
    multiline
    // error={formik.touched[name] && Boolean(formik.errors[name])}
    // helperText={formik.errors[name]}
    {...props}
  />
);

const CRMAssignation = ({ rowData, dispatchdata }) => {
  const [open, setOpen] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [data, setdata] = useState({});

  const { croList, loading } = useSelector((state) => state.crm);
  const { paginationData } = useSelector((state) => state.globalDataGrid);

  const ValidationSchema = Yup.object().shape({
    assigned: Yup.string().required("Please select a CRO"),
    // remarks: Yup.string().required("Please add Remarks"),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      assigned_by: "",
      remarks: "",
      course_enrollment_id: rowData.course_enrollment_id,
      assigned: "",
    },
    validationSchema: ValidationSchema,
    onSubmit: (values) => {
      dispatch(assignCros(values)).then((res) => {
        console.log(res);
        if (res.payload.status === "success") {
          enqueueSnackbar(res.payload.message, {
            variant: "success",
          });
          dispatch(getCrmLeads(dispatchdata));
          setOpen(false);
          dispatch(
            savePaginationData({ ...paginationData, openAnchor: false })
          );
        } else {
          enqueueSnackbar(res.payload.message, {
            variant: "error",
          });
        }
      });
    },
  });

  const dispatch = useDispatch();

  useEffect(() => {
    if (open) {
      dispatch(
        getCroList({
          search: "",
        })
      );
    }
  }, [open]);

  const textFields = [
    { name: "name", label: "Name" },
    { name: "admn_no", label: "Admission Number" },
    { name: "class", label: "Class" },
    { name: "assigned_course_name", label: "Course" },
    { name: "contactNumber", label: "Contact Number" },
    { name: "assigned_to", label: "Assigned To CRO" },
    { name: "crm_status", label: "CRM Status" },
    { name: "student_status", label: "Student Status" },
  ];

  return (
    <GlobalDialog
      title={"Assign CRO"}
      open={open}
      setOpen={setOpen}
      fullWidth
      closeButton={true}
      popupButton={
        <AddButton
          disabled={rowData.first_fee_payment_date === null}
          size="medium"
          action={() => setOpen(true)}
        >
          Assign CRO
        </AddButton>
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Box>
                <Stack direction={"column"} spacing={2}>
                  {textFields.map((item, index) => {
                    return (
                      <Box key={index}>
                        <CustomTextField
                          name={item.name}
                          label={item.label}
                          dataRow={rowData}
                        />
                      </Box>
                    );
                  })}
                  <Autocomplete
                    options={croList}
                    getOptionLabel={(option) => option.name}
                    onChange={(event, value) =>
                      formik.setFieldValue("assigned", value?.userID || "")
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Assigned CRO"
                        variant="outlined"
                        error={
                          formik.touched.assigned &&
                          Boolean(formik.errors.assigned)
                        }
                        helperText={
                          formik.touched.assigned && formik.errors.assigned
                        }
                      />
                    )}
                  />
                  <TextField
                    name="remarks"
                    value={formik.values.remarks}
                    error={
                      formik.touched.remarks && Boolean(formik.errors.remarks)
                    }
                    helperText={formik.errors.remarks}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Remarks"
                  />
                </Stack>
                <Box
                  sx={{ display: "flex", justifyContent: "flex-end", pt: 2 }}
                >
                  <Stack direction={"row"} spacing={1}>
                    <CancelButton size="small" action={() => setOpen(false)}>
                      Cancel
                    </CancelButton>
                    <SubmitButton disabled={loading} size="small" type="submit">
                      {loading ? "Please wait..." : "Assign"}
                    </SubmitButton>
                  </Stack>
                </Box>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default CRMAssignation;
